import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

import Header from '../components/Header';
import Appfooter from '../components/Appfooter';
import LeftMenu from '../components/LeftMenu';
import { Form, Spinner } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { bankingInstitutionsData } from '../utils/data';
import {
  getBankAccount,
  saveAccountBank,
  updateBankAccount,
} from '../services/creator';
import { Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { validateCNPJ, validateCPF } from '../utils/validation';
import Button from '../components/Button';

const PayoutAccount = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    touched,
    isValid,
    values,
    errors,
  } = useFormik({
    initialValues: {
      documentType: 'CPF',
      document: '',
      name: '',
      pixKey: '',
      bank: '',
      id: '',
    },
    onSubmit,
    validateOnBlur: true,
    validationSchema: Yup.object().shape({
      documentType: Yup.string().required('Selecione o tipo de documento'),
      document: Yup.string()
        .required('CPF ou CNPJ é obrigatório')
        .test('is-valid-document', function (value) {
          const { documentType } = this.parent;
          if (documentType === 'CPF') {
            return validateCPF(value || '')
              ? true
              : this.createError({ message: 'CPF inválido' });
          } else if (documentType === 'CNPJ') {
            return validateCNPJ(value || '')
              ? true
              : this.createError({ message: 'CNPJ inválido' });
          }
          return false;
        }),
      name: Yup.string()
        .required('Nome completo ou razão social é obrigatório')
        .min(3, 'Nome deve ter pelo menos 3 caracteres'),
      pixKey: Yup.string()
        .required('Chave PIX é obrigatória')
        .test('is-valid-pix', 'Chave PIX inválida', function (value) {
          if (!value) return false;
          // Email
          if (value.includes('@')) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          }
          // CPF/CNPJ
          if (/^\d+$/.test(value.replace(/[.-]/g, ''))) {
            return validateCPF(value) || validateCNPJ(value);
          }
          // Telefone
          if (/^\+?\d{10,15}$/.test(value.replace(/\D/g, ''))) {
            return true;
          }
          // Chave aleatória
          if (
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
              value
            )
          ) {
            return true;
          }
          return false;
        }),
      bank: Yup.string().required('Selecione a instituição bancária'),
    }),
  });

  useEffect(() => {
    async function fetchBankAccount() {
      try {
        setLoading(true);

        const bankAccount = await getBankAccount();

        setFieldValue('documentType', bankAccount.documentType);
        setFieldValue('document', bankAccount.document);
        setFieldValue('name', bankAccount.name);
        setFieldValue('pixKey', bankAccount.pixKey);
        setFieldValue('bank', bankAccount.bank);
        setFieldValue('id', bankAccount.id);
      } catch (error: any) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }

    fetchBankAccount();
  }, [setFieldValue]);

  async function onSubmit(values: BankAccount) {
    try {
      setLoading(true);

      const bankAccount: BankAccount = {
        ...values,
        document: values.document.replace(/\D/g, ''),
      };

      if (values.id) {
        await updateBankAccount(bankAccount);
        setShowConfirmationModal(true);
        return;
      }

      await saveAccountBank(bankAccount);

      setShowConfirmationModal(true);
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const bankingInstitutions = useMemo(() => {
    const banks: { label: string; value: string }[] = [];

    for (const bank of bankingInstitutionsData) {
      banks.push({
        label: bank.value,
        value: bank.value,
      });
    }

    // Sort by the numeric part of the label
    return banks.sort((a, b) => {
      const numA = parseInt(a.label.split(' - ')[0], 10); // Extract the numeric part
      const numB = parseInt(b.label.split(' - ')[0], 10); // Extract the numeric part
      return numA - numB; // Compare the numeric parts
    });
  }, []);

  return (
    <>
      <Header />
      <LeftMenu />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0" style={{ marginBottom: '100px' }}>
                <div className="card-body p-4 w-100 border-0 d-flex rounded-3">
                  <button
                    onClick={() => navigate(-1)}
                    className="d-inline-block mt-2 bg-transparent border-0"
                  >
                    <i className="ti-arrow-left font-sm text-black"></i>
                  </button>
                  <h4 className="font-xs text-black fw-600 ms-4 mb-0 mt-2">
                    Conta de Recebimento
                  </h4>
                </div>
                <div className="p-4 d-flex justify-content-center">
                  {loading ? (
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-warning mt-3"
                    />
                  ) : (
                    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                      {/* <div
                        className="alert alert-warning d-flex align-items-start mb-4"
                        style={{
                          backgroundColor: '#fff8e1',
                          border: '1px solid #ffeeba',
                          borderRadius: '8px',
                          padding: '16px',
                        }}
                      >
                        <i
                          className="feather-alert-triangle text-warning me-3 mt-1"
                          style={{ fontSize: '20px' }}
                        ></i>
                        <div className="flex-grow-1">
                          <p className="font-xsss fw-600 mb-0 text-dark">
                            <span className="text-warning">Atenção:</span> O
                            proprietário da conta bancária precisa ser o mesmo
                            que o titular da conta na plataforma. Caso ocorra
                            alguma divergência, a solicitação de saque será
                            cancelada.
                          </p>
                        </div>
                      </div> */}
                      <div className="form-group mb-3">
                        <Form className="d-flex mb-4">
                          <Form.Check
                            type="radio"
                            label="CPF"
                            name="documentType"
                            checked={values.documentType === 'CPF'}
                            onChange={() =>
                              setFieldValue('documentType', 'CPF')
                            }
                            className="me-3 font-xsss fw-600 text-grey-700"
                          />
                          <Form.Check
                            type="radio"
                            label="CNPJ"
                            name="documentType"
                            checked={values.documentType === 'CNPJ'}
                            onChange={() =>
                              setFieldValue('documentType', 'CNPJ')
                            }
                            className="font-xsss fw-600 text-grey-700"
                          />
                        </Form>
                      </div>
                      <div className="form-group mb-3">
                        {values.documentType === 'CPF' ? (
                          <InputMask
                            className="form-control font-xss"
                            mask="999.999.999-99"
                            placeholder="000.000.000-00"
                            value={values.document}
                            name="document"
                            id="document"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        ) : (
                          <InputMask
                            className="form-control font-xss"
                            mask="99.999.999/9999-99"
                            placeholder="00.000.000/0000-00"
                            value={values.document}
                            name="document"
                            id="document"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        )}
                        <span className="text-danger font-xsss fw-500">
                          {touched.document && errors.document
                            ? errors.document
                            : ''}
                        </span>
                      </div>
                      <div className="form-group mb-3">
                        {values.documentType === 'CPF' ? (
                          <>
                            <label className="mont-font fw-600 font-xsss mb-2 mt-2">
                              Nome Completo
                            </label>
                            <input
                              type="text"
                              className="form-control font-xss"
                              value={values.name}
                              placeholder={'Nome Completo'}
                              name="name"
                              id="name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </>
                        ) : (
                          <>
                            <label className="mont-font fw-600 font-xsss mb-2 mt-2">
                              Razão Social
                            </label>
                            <input
                              type="text"
                              className="form-control font-xss"
                              value={values.name}
                              placeholder="Razão Social"
                              name="name"
                              id="name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </>
                        )}
                        <span className="text-danger font-xsss fw-500">
                          {touched.name && errors.name ? errors.name : ''}
                        </span>
                      </div>
                      <div className="form-group mb-3">
                        <label className="mont-font fw-600 font-xsss mb-2 mt-2">
                          Chave PIX
                        </label>
                        <input
                          type="text"
                          className="form-control font-xss"
                          value={values.pixKey}
                          placeholder={'Chave Pix'}
                          name="pixKey"
                          id="pixKey"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                        <span className="text-danger font-xsss fw-500">
                          {touched.pixKey && errors.pixKey ? errors.pixKey : ''}
                        </span>
                      </div>
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss mb-2 mt-2">
                          Instituição Bancária
                        </label>
                        <Select
                          onChange={(bank: any) => {
                            setFieldValue('bank', bank?.value || '');
                          }}
                          onBlur={() => setFieldValue('touched.bank', true)}
                          className="font-xss"
                          value={
                            values.bank
                              ? {
                                  label: values.bank,
                                  value: values.bank,
                                }
                              : null
                          }
                          placeholder="Instituição Bancária"
                          options={bankingInstitutions}
                          isClearable
                        />
                        <span className="text-danger font-xsss fw-500">
                          {touched.bank && errors.bank ? errors.bank : ''}
                        </span>
                      </div>
                      <div className="d-flex justify-content-center align-items-center mt-5">
                        <Button type="submit" disabled={!isValid}>
                          Salvar dados bancários
                        </Button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showConfirmationModal}>
        <Modal.Header
          closeButton
          onClick={() => setShowConfirmationModal(false)}
          className="bg-white"
          style={{
            border: 0,
            borderRadius: 0,
            padding: 20,
            borderTopLeftRadius: 10,
            WebkitBorderTopRightRadius: 10,
          }}
        />
        <Modal.Body className="bg-white">
          <p className="font-xs text-black text-center">
            Os dados bancários foram salvos com sucesso!
          </p>
        </Modal.Body>
        <Modal.Footer className="bg-white d-flex flex-row">
          <div className="form-group mb-1 flex-grow-1">
            <Button onClick={() => setShowConfirmationModal(false)}>OK</Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Appfooter />
    </>
  );
};

export default PayoutAccount;
